import { Skeleton } from '@/components/ui/skeleton.component';
import { ContentContainer } from '@/components/ui/content-container.component';

export default function SearchCardLoading() {
  return (
    <div className="w-full md:pb-10">
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className={`w-full ${index === 0 ? '' : 'md:mt-5'}`}>
          <ContentContainer className="md:px-0 md:mx-auto md:max-w-[576px] lg:max-w-3xl">
            <div className="bg-white py-5 md:border md:border-gray-300 md:p-6 md:rounded-xxl w-full xl:grid xl:grid-cols-2 xl:gap-12 xl:items-start">
              <div className="flex">
                <Skeleton className="shrink-0 w-22 h-22" />
                <div className="ml-4">
                  <Skeleton className="h-5 w-44 md:w-64 md:mt-2" />
                  <Skeleton className="h-5 w-12 md:w-12 mt-2" />
                  <Skeleton className="md:h-5 md:w-96 mt-2" />
                  <Skeleton className="md:h-5 md:w-24 mt-2" />
                </div>
              </div>
              <div className="justify-between flex md:hidden">
                <div>
                  <Skeleton className="h-5 w-36 mt-4 " />
                </div>
                <div>
                  <Skeleton className="h-5 w-5 mt-4" />
                </div>
              </div>
              <div className="flex xl:block mt-3 xl:mt-0 gap-2">
                <Skeleton className="h-10 w-1/2 md:h-11 md:w-full xl:w-full" />
                <Skeleton className="h-10 w-1/2 md:h-11 md:w-36 xl:w-full xl:mt-2" />
              </div>
            </div>
          </ContentContainer>
          <hr className="border-gray-300 w-full md:hidden" />
        </div>
      ))}
    </div>
  );
}
